module.exports = __webpack_public_path__ + "img/havanna_oak_662m_detail_rsh.efdc7865.jpg";